import palette from '../../../../theme/palette';

export default () => ({
  filterInput: {
    width: '100%',
    '@media (min-width: 1366px)': {
      width: '17.5rem',
    },
    '@media (min-width: 1600px)': {
      width: '24rem',
    },
    '& label': {
      color: 'rgba(0, 0, 0, 0.6)',
      fontSize: '0.6rem',
      '@media (min-width: 1200px)': {
        fontSize: '1rem',
      },
    },
    '& .MuiSvgIcon-root': {
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
  buttonClearFilter: {
    marginRight: '1rem',
  },
  searchIcon: {
    color: 'rgba(0, 0, 0, 0.87)',
  },
});

export const ListagemPlanosTableRowStyles = {
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  tableCell: {
    fontSize: '13px',
    lineHeight: '18px',
    color: palette.text.secondary,
    padding: '8px 16px',
  },
  tr: {
    height: '48px',
  },
  tableRow: {
    backgroundColor: '#fff',
    height: '48px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  actionIconButton: {
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      backgroundColor: 'rgba(25, 118, 210, 0.12)',
      opacity: 0,
      transition: 'opacity 0.2s ease',
      pointerEvents: 'none',
      zIndex: 0,
    },
    '&:hover::before': {
      opacity: 1,
    },
    '& .MuiSvgIcon-root': {
      position: 'relative',
      zIndex: 1,
    },
  },
};
